// ─── Config partagée (Core) ───────────────────────────────────────
// Documents de configuration lus par toutes les apps de la suite, dans la base
// PAR DÉFAUT (mêmes docs que MoPCal → un seul réglage admin pour tout).
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

// config/pub → { banniereFixe:{ actif, url }, pleinEcran:{…} }
export function ecouterConfigPub(callback) {
  return onSnapshot(
    doc(db, 'config', 'pub'),
    snap => callback(snap.exists() ? snap.data() : {}),
    () => callback({}),
  );
}

// config/version — dernière version publiée, PAR APPLICATION.
//   { derniere: '3.15.x',            ← historique : MoPCal
//     apps: { 'mop-inventory': '0.2.0', 'mop-empty': '0.1.0', … } }
// Chaque app a son propre cycle de versions : on ne compare jamais la version
// d'une app à celle d'une autre (sinon faux « mettre à jour »).
// Inconnue → null → le pied affiche « en attente… » (jamais de fausse alerte).
export function ecouterDerniereVersion(appId, callback) {
  return onSnapshot(
    doc(db, 'config', 'version'),
    snap => {
      const d = snap.exists() ? (snap.data() || {}) : {};
      const parApp = d.apps && d.apps[appId];
      // `derniere` reste la version de MoPCal (compat. historique).
      const v = parApp != null ? parApp : (appId === 'mop-cal' ? (d.derniere || null) : null);
      callback(v || null);
    },
    () => callback(null),
  );
}
